<script>
/**
 * ****************************************************************************
 * @description     :   Input DatePicker Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import flatPickr from 'vue-flatpickr-component';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input datepicker component
 */
var FcDatePicker = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        placeholder: String,
        value: String,
        modelValue: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function,
        onFocus: Function,
        onBlur: Function
    },
    components: {
        flatPickr
    },
    emits: ['update:modelValue'],
    data() {
        return {
            config: {
                wrap: true,
                altFormat: 'Y/m/d',
                altInput: true,
                dateFormat: 'Y/m/d',
                allowInput: true,
                clickOpens: false,
                monthSelectorType: 'static',
                locale: Japanese,
                onChange: this.updateInput,
                onKeyDown: this.inputKeydown
            }
        };
    },
    computed: {
        vewValue: {
            get() {
                return this.convertDateString(
                    this.modelValue ? this.modelValue : this.value
                );
            },
            set(dateStr) {
                if (this.vewValue != dateStr) {
                    this.$emit('update:modelValue', dateStr);
                    if (this.onChange) {
                        this.onChange(dateStr);
                    }
                }
            }
        }
    },
    methods: {
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        convertDateString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-9]{8}$/;
            var reg2 = /^[0-9]{4}[/.][0-9]{2}[/.][0-9]{2}$/;
            if (value.match(reg1)) {
                value =
                    value.substring(0, 4) +
                    '/' +
                    value.substring(4, 6) +
                    '/' +
                    value.substring(6);
            }
            if (!value.match(reg1) && !value.match(reg2)) {
                value = '';
            }
            if (!this.isDate(value)) {
                value = '';
            }
            return value;
        },
        /**
         * Check date type for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        isDate(string) {
            if (string == '') {
                return true;
            }
            if (string.length == 8) {
                string =
                    string.substring(0, 4) +
                    '/' +
                    string.substring(4, 6) +
                    '/' +
                    string.substring(6);
            }
            var reg =
                /^((19|[2-9][0-9])[0-9]{2})[/.](0[13578]|1[02])[/.]31|((19|[2-9][0-9])[0-9]{2}[/.](01|0[3-9]|1[0-2])[/.](29|30))|((19|[2-9][0-9])[0-9]{2}[/.](0[1-9]|1[0-2])[/.](0[1-9]|1[0-9]|2[0-8]))|((((19|[2-9][0-9])(04|08|[2468][048]|[13579][26]))|2000)[/.](02)[/.]29)$/;
            if (string.match(reg)) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * event keydown on input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        inputKeydown(selectedDates, dateStr, instance, e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 191
                )
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * update input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(selectedDates, dateStr) {
            if (this.vewValue != dateStr) {
                this.$emit('update:modelValue', dateStr);
                if (this.onChange) {
                    this.onChange(dateStr, selectedDates);
                }
            }
        }
    }
};
export default FcDatePicker;
</script>
